module.exports = __webpack_public_path__ + "static/media/bg01a.7a32c042.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg01a.png
// module id = 97
// module chunks = 0